import { render, staticRenderFns } from "./walletDetail.vue?vue&type=template&id=10f1c7e7&lang=pug&"
import script from "./walletDetail.vue?vue&type=script&lang=js&"
export * from "./walletDetail.vue?vue&type=script&lang=js&"
import style0 from "./walletDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports